let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l5ljU")).then(() => parcelRequire('4QluW'));